
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientDocuments',
  data () {
    return {
      tab: null,
      documentType: ['NRIC', 'Passport', 'TIN', 'SS', 'HRN', 'ePhil ID', 'Unknown']
    }
  }
})
